import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import {
  B4,
  B5,
  BTN,
  Button,
  Icon,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import ApplicationInProgress from '@zet/feature-leads/components/applicationInProgress'
import LeadAdded from '@zet/feature-leads/components/leadAdded'
import LeadCrossSelling from '@zet/feature-leads/components/leadCrossSelling'
import LeadExpired from '@zet/feature-leads/components/leadExpired'
import LeadFulFilled from '@zet/feature-leads/components/leadFulFilled'
import LeadPartlyFulFilled from '@zet/feature-leads/components/leadPartlyFulFilled'
import LeadRejected from '@zet/feature-leads/components/leadRejected'
import { LeadDetailsType } from '@zet/feature-leads/types'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'
import { LoggedInNavigation } from '@zet/utils/interface'

import PaymentCard from './paymentCard'

type StatusCardProps = {
  item?: LeadDetailsType
  brandComms?: object
  brandName?: string
  hideBottomView?: boolean
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>
}

const StatusCard = ({
  item,
  brandComms,
  brandName,
  hideBottomView,
  setOpenBottomSheet,
}: StatusCardProps) => {
  const { navigate } = useNavigation<LoggedInNavigation>()
  const status = item?.status
  const videoId = brandComms?.applicationProcess?.videoLink
  const payoutDetails = brandComms?.commission
  const customerName = item?.name
  const phone = item?.phoneNumber
  const customerId = item?.customerId
  const inactive = brandComms?.inactive
  const { data: user } = useUserContext()

  const offers = () => {
    return (
      <>
        <Stack className="mx-3 mt-4 ">
          <Button
            fullWidth
            outlined
            size={'sm'}
            className={'px-4/2 items-center justify-center py-2'}
            onPress={() =>
              navigate('BrandPage', {
                customerName: customerName,
                customerPhoneNumber: phone,
                customerId: customerId,
                routeName: 'forCustomerFlow',
              })
            }
            iconRight={
              <Icon type="ArrowRight" color={zetColors.primary[100]} />
            }
            eventName="click_action"
            eventPayload={{
              item_name: 'lead_page_more_offers',
              lead_id: item?.id,
              lead_status: status,
              user_id: user?.id,
              customer_id: item?.customerId,
              partner_id: item?.partnerId,
              brand_name: brandName,
              brand_category: brandComms?.subCategory,
            }}
          >
            <BTN className="text-primary-100 mr-2 text-center">
              {i18n.t('leads.offers', { customer: customerName })}
            </BTN>
          </Button>
        </Stack>
      </>
    )
  }

  return (
    <Stack className="bg-grays-20 pb-3">
      <XStack className="items-center justify-between px-[20]">
        <B4 className=" py-4/2 text-grays-80">
          {i18n.t('leads.leadProgress')}
        </B4>
        {item?.referenceId && (
          <B5>{i18n.t('leads.arn', { referenceId: item?.referenceId })}</B5>
        )}
      </XStack>
      {status == LeadStatus.LEAD_ADDED ? (
        <Stack>
          <LeadAdded
            item={item}
            videoId={videoId}
            brandName={brandName}
            inactive={inactive}
          />
          <ApplicationInProgress
            item={item}
            videoId={videoId}
            brandName={brandName}
            inactive={inactive}
            brandComms={brandComms}
          />
          <LeadFulFilled item={item} payoutDetails={payoutDetails} />
        </Stack>
      ) : status == LeadStatus.ACTION_REQUIRED ? (
        <Stack>
          <LeadAdded item={item} videoId={videoId} inactive={inactive} />
          <ApplicationInProgress
            item={item}
            videoId={videoId}
            brandName={brandName}
            inactive={inactive}
            brandComms={brandComms}
          />
          <LeadFulFilled item={item} payoutDetails={payoutDetails} />
        </Stack>
      ) : status == LeadStatus.EXPIRED ? (
        <Stack>
          <LeadAdded item={item} videoId={videoId} />
          <LeadExpired item={item} brandName={brandName} inactive={inactive} />
          {offers()}
        </Stack>
      ) : status == LeadStatus.REJECTED ? (
        <Stack>
          <LeadAdded item={item} videoId={videoId} />
          <LeadRejected item={item} brandName={brandName} inactive={inactive} />
          <PaymentCard
            item={item}
            brandName={brandName}
            hideBottomView={hideBottomView}
            setOpenBottomSheet={setOpenBottomSheet}
          />
          <LeadCrossSelling leadId={item?.id} customerId={item?.customerId} />
          {offers()}
        </Stack>
      ) : status == LeadStatus.FULLFILLED ? (
        <Stack>
          <LeadAdded item={item} videoId={videoId} />
          <LeadFulFilled
            item={item}
            payoutDetails={payoutDetails}
            brandName={brandName}
          />
          <PaymentCard
            item={item}
            brandName={brandName}
            hideBottomView={hideBottomView}
            setOpenBottomSheet={setOpenBottomSheet}
          />
          {offers()}
        </Stack>
      ) : status == LeadStatus.PARTIALLY_FULLFILLED ? (
        <Stack>
          <LeadAdded item={item} videoId={videoId} />
          <LeadPartlyFulFilled item={item} />
          <PaymentCard
            item={item}
            brandName={brandName}
            hideBottomView={hideBottomView}
            setOpenBottomSheet={setOpenBottomSheet}
          />
          {offers()}
        </Stack>
      ) : null}
    </Stack>
  )
}

export { StatusCard }
